import type { Store } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";
import type { HostedErrors, WebsiteChoice } from "../../../onboarding-website/onboarding-website-model";

export class WebsiteSectionState {
  readonly store = new Rx<Store | null>(null);
  readonly mode = new Rx<WebsiteChoice>("own");
  readonly websiteUrl = new Rx("");
  readonly slug = new Rx("");
  readonly contactEmail = new Rx("");
  readonly returnsPolicy = new Rx("");
  readonly hostedErrors = new Rx<HostedErrors>({});
  readonly slugProblem = new Rx<string | null>(null);
  /** Whether any branch has an address the page can print. */
  readonly hasMappableLocation = new Rx(false);
  readonly error = new Rx<string | null>(null);
  readonly saved = new Rx(false);
  readonly busy = new Rx(false);
}

export abstract class WebsiteSectionActions {
  abstract setMode(mode: WebsiteChoice): void;
  abstract setWebsiteUrl(value: string): void;
  abstract setSlug(value: string): void;
  abstract setContactEmail(value: string): void;
  abstract setReturnsPolicy(value: string): void;
  abstract save(): Promise<void>;
}
